<template>
  <div class="m-reading">
    <p><i>The following is a reading by our brother, Phil Dieke, during the ceremony.</i></p>

    <p>Ian and Evan as you hear these words from the author and poet John O’Donohue, may they not only inspire you this day, but continue to empower and sustain the love you share all the days of lives together:</p>

    <blockquote>
      <p>Every human heart hungers for love. If you do not have the warmth of love in your heart, there is no possibility of real celebration and enjoyment. No matter how hard, competent, self-assured or respected you are, no matter what you think of yourself or what others think of you, the one thing you deeply long for is love. No matter where we are, who we are or what we are, or what kind of journey we are on, we all need love.</p>

      <p>Love is absolutely vital for human life. For love alone can awaken what is divine within you. In love, you grow and come home to your self. When you learn to love and to let your self be loved, you come home to the hearth of your own spirit. You are warm and sheltered. You are completely at one in the house of your own longing and belonging. In that growth and homecoming is the unlooked-for bonus in the act of loving another.

      <p>When you love, you open your life to an Other. All your barriers are down. Your protective distances collapse. This person is given absolute permission to come into the deepest temple of you spirit. Your presence and life can become their ground. It takes great courage to let someone so close. Since the body is in the soul, when you let someone so near, you let them become part of you. In the sacred kinship of real love two souls are twinned. The outer shell and contour of identity becomes porous. You suffuse each other.</p>

      <p>When two people fall in love, each comes in out of the loneliness of exile, home to the one house of belonging. At weddings, it is appropriate to acknowledge the gracious destiny that enabled this couple to recognize each other when they met. Each recognized the other as the one in whom their heart could be at home… To be holy is to be home, to be able to rest in the house of belonging that we call the soul. Love is the nature of the soul. When we love and allow our selves to be loved, we begin more and more to inhabit the kingdom of the eternal.</p>

      <p>The greatest gift new love brings into your life is the awakening to the hidden love within. A person should always offer a prayer of graciousness for the love that has awakened in them. When you feel love for your beloved and his love for you, now and again you should offer the warmth of your love as a blessing for those who are damaged and unloved. Send that love out into the world to people who are desperate; to those who are starving; to those who are trapped in prison; in hospitals and all the brutal terrains of bleak and tormented lives. When you send that love out from the bountifulness of your own love, it reaches other people.</p>

      <p>There is a lovely idea in the Celtic tradition that if you send out goodness from your self, or if you share that which is happy or good within you, it will all come back to you multiplied ten thousand times. In the kingdom of love there is no competition; there is no possessiveness or control. The more love you give away, the more love you will have.</p>
    </blockquote>

    <p>Ian and Evan, may you both be blessed by love and may your love be a blessing to all the world.</p>

    <p>Amen.</p>


  </div>
</template>

<script>

export default {
  name: 'reading'
}
</script>

<style lang="scss">
.m-reading {
  blockquote {
    border-left: 2px solid $gold;
    padding-left: 1em;
    margin-left: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reading.vue